export default {
  query: null,
  lawsuits: [],
  pagination: null,
  detail: null,
  isLoadingQuery: false,
  isLoadingLawsuits: false,
  isLoadingDetail: false,
  isCreatingQuery: false,
  error: null
}



// WEBPACK FOOTER //
// ./src/store/modules/judicial_lawsuits/state.js